import { render, staticRenderFns } from "./ds-textarea.vue?vue&type=template&id=d9a75646"
import script from "./ds-textarea.vue?vue&type=script&lang=ts"
export * from "./ds-textarea.vue?vue&type=script&lang=ts"
import style0 from "./ds-textarea.vue?vue&type=style&index=0&id=d9a75646&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports